import styled from "styled-components";
import { Link } from 'react-router-dom';

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 6% auto;
  
  background: #FFFFFF;
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;
  
  margin:0px auto 15px auto;
  padding-bottom: 5px;

  color:#000000;

  border-bottom: 1px solid rgba(0, 0, 0, .15);

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;
`;

export const Field = styled.div`
  width: 100%;
  margin: 15px 0px;
`
export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;

  color: rgba(0,0,0,0.87);
`

export const Input = styled.input`
  width:100%;
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;

export const Button = styled.button`
  width: 130px;
  height: 35px;

  background: rgba(0,0,0,.87) !important;
  color: #FFFFFF;

  font-size:14px;
  font-weight: 600;

  border: 0px;
  border-radius: 5px;

  cursor: pointer;
  transition: all 0.5s;

  &:hover{
    background: rgba(0,0,0,.7);
  }
`
